import React from 'react';
//styles
import 'src/asset/scss/plugin/modalPopup.scss';
import styles from 'src/asset/scss/styles/userMemberInfo.module.scss';
//comp
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목

export default function form(props) {
    const inputRef = props.inputRef;
    const data = props.data;

    //validateCheck
    const onValidateHandler = () => {
        if(data !== null && (Number(inputRef.current[0].value.replaceAll(",", "")) === Number(data.current.KMLE.replaceAll(",", "")))) { props.onValid(null, true); return; }
        for(let i = 0; i < inputRef.current.length; i++) {
            if(inputRef.current[i].value.length <= 0) { props.onValid(null, true); return; } 
        }
        
        props.onValid(null, false);
    }

    //const { onNumberCommaHandler } = useComnHook();//axios
    //숫자만입력(세자리콤마)
    const onNumberCommaHandler = (e) => {
        let value = e.target.value;
        let nval = Number(value.replaceAll(',', ''));
        if(!isNaN(nval)) { nval = nval.toLocaleString('ko-KR'); } 
        else { nval = ''; }
        e.target.value = nval;
    };

    return ( 
        <div className={["popupFormArea", styles.popupFormArea].join(" ")}>
            <FormWrapper>
                <TitleWrapper title={'변경할 주행거리'}/>
                <div className="textArea">
                    <input onChange={(e) => { onNumberCommaHandler(e); onValidateHandler()}}
                        ref={el => (inputRef.current[0] = el)}
                        type="text" inputMode="text" placeholder="변경할 주행거리를 입력하세요."
                        className="txtRight" />
                    <span>km</span>
                </div>
            </FormWrapper>
        </div>
    );
}